<template>
  <div class="wrapper">
    <navigation-bar />
    <router-view />
  </div>
</template>

<script>
import NavigationBar from '@/components/parts/NavigationBar'

export default {
  components: { NavigationBar },
}
</script>

<style lang="scss" scoped></style>
